<template>
    <v-switch
        v-model="localValue"
        :dense="!isMobile"
        hide-details="auto"
        :label="label"
        class="c-switch"
    ></v-switch>
</template>

<script>
export default {
    props: {
        value: {type: Boolean, default: null},
        label: {type: String, default: null}
    },
    data() {
        return {
            localValue: this.value,
        };
    },
    watch: {
        value(v) {
            this.localValue = v;
        },
        localValue(v) {
            this.$emit('input', v);
            this.$emit('change', v);
        }
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.xs;
        }
    }
}
</script>

<style lang="scss">
.c-switch {
    .v-label {
        flex: inherit !important;
    }
}
</style>